import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "Modal__dialogHeading" }
const _hoisted_2 = { class: "Modal__contentContainer" }
const _hoisted_3 = {
  key: 0,
  class: "Modal__controls"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "Modal__overlay",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggle(false, $event)), ["self"]))
    }),
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['Modal Modal__dialog Modal__dialog__mobileFullWidth', { Modal__dialog_exit: _ctx.modalExiting }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "header"),
            _createElementVNode("button", {
              class: "Modal__closeButton",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggle(false)), ["self"]))
            }, [
              _createElementVNode("div", {
                class: "Modal__closeIcon",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggle(false)), ["self"]))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "body")
          ]),
          (_ctx.hasFooterSlot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}